import { useCallback, useState } from 'react';

export type SetState<S extends Record<string, any>> = <K extends keyof S>(
    state: Pick<S, K> | null | ((prevState: Readonly<S>) => Pick<S, K> | S | null),
  ) => void;

export const useSetState = <S extends Record<string, any>>(
    initialState: S | (() => S),
): [S, SetState<S>] => {
    const [state, setState] = useState<S>(initialState);
    const setMergeState = useCallback((arg: any) => {
        setState((prevState) => {
            const newState = typeof arg === 'function' ? arg(prevState) : arg;
            return newState ? { ...prevState, ...newState } : prevState;
        });
    }, []);
    return [state, setMergeState];
};

export default useSetState;
